import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../../data/content";
import { SectionHeading, Reveal } from "../primitives";

export default function Testimonials() {
  return (
    <section data-testid="testimonials" className="relative mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32">
      <SectionHeading
        eyebrow="Client voices"
        title="Businesses that trust us"
        sub="We measure success by long-term relationships. Here's what working with Nova SecureNet feels like."
        align="center"
      />

      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.1}>
            <motion.figure
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 280, damping: 20 }}
              className="flex h-full flex-col rounded-3xl border border-white/10 bg-white/[0.03] p-8"
            >
              <Quote className="h-8 w-8 text-brand" strokeWidth={1.5} />
              <blockquote className="mt-5 flex-1 text-[15px] leading-relaxed text-white/85">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6 border-t border-white/10 pt-5">
                <div className="font-heading text-sm font-semibold text-white">{t.name}</div>
                <div className="mt-0.5 text-xs text-muted-foreground">{t.role}</div>
              </figcaption>
            </motion.figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
